module.exports = __webpack_public_path__ + "img/word.6fcc41ba.svg";